<div class="employee-page core-screen">
  @if (loading()) {
  <div class="loading">
    <span>{{ 'common.loading' | translate }}</span>
  </div>
  } @else if (errorKind()) {
  <div class="empty-state">
    <div class="empty-state__content">
      <img class="empty-state__icon" src="/icons/unboxing.svg" alt="" />
      <h2 class="empty-state__title">
        {{
          (errorKind() === 'notFound'
            ? 'admin.employees.detailNotFoundTitle'
            : 'admin.employees.detailLoadErrorTitle'
          ) | translate
        }}
      </h2>
      <p class="empty-state__description">
        {{
          (errorKind() === 'notFound'
            ? 'admin.employees.detailNotFoundDescription'
            : 'admin.employees.detailLoadErrorDescription'
          ) | translate
        }}
      </p>
    </div>
  </div>
  } @else if (employee(); as emp) {
  <div class="employee-content">
    <div class="employee-header">
      <div
        class="employee-icon"
        [class.employee-icon--has-photo]="!!emp.user.photo_url?.trim()"
        [class.employee-icon--deactivated]="!emp.is_active"
      >
        @if (emp.user.photo_url?.trim(); as photoUrl) {
          <img
            class="employee-icon__img"
            [src]="photoUrl"
            alt=""
            loading="lazy"
            decoding="async"
          />
        } @else {
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <circle cx="12" cy="8" r="4" stroke="white" stroke-width="2" />
            <path
              d="M6 21c0-3.314 2.686-6 6-6s6 2.686 6 6"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        }
      </div>
      <div class="employee-title">
        <h1 class="employee-name">{{ formatName(emp) }}</h1>
        <div class="employee-status" [class.active]="emp.is_active">
          {{ emp.is_active ? ('warehouse.status.active' | translate) :
          ('warehouse.status.inactive' | translate) }}
        </div>
      </div>
      <div class="employee-header-actions">
        @if (mayPrintNameBadge()) {
        <button
          type="button"
          class="header-action-button"
          (click)="onPrintNameBadge()"
          [disabled]="printingNameBadge()"
          [attr.aria-label]="'admin.employees.actions.printNameBadge' | translate"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M6 9V2h12v7"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6 14h12v8H6z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        }
        <button
          type="button"
          class="header-action-button"
          (click)="onEdit()"
          [attr.aria-label]="'admin.employees.actions.edit' | translate"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>

    <div class="contact-actions">
      <a class="contact-button" [href]="'tel:' + emp.user.phone">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path
            d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </a>
      @if (emp.user.email) {
      <a class="contact-button" [href]="'mailto:' + emp.user.email">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path
            d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <polyline
            points="22,6 12,13 2,6"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </a>
      } @if (emp.telegram_link) {
      <a
        class="contact-button"
        [href]="emp.telegram_link"
        target="_blank"
        rel="noopener"
      >
        <img src="/icons/socials/telegram.svg" alt="" width="20" height="20" />
      </a>
      }
    </div>

    <div class="info-card">
      @if (emp.position) {
        <div class="info-row">
          <span class="info-label">{{ 'employee.position' | translate }}</span>
          <span class="info-value">{{ emp.position }}</span>
        </div>
      }
      @if (emp.acts_on_basis) {
        <div class="info-row">
          <span class="info-label">{{ 'admin.employees.create.actsOnBasisLabel' | translate }}</span>
          <span class="info-value">{{ emp.acts_on_basis }}</span>
        </div>
      }
      <div class="info-row">
        <span class="info-label">{{ 'employee.phone' | translate }}</span>
        <div class="info-value-with-copy">
          <span class="info-value">{{ emp.user.phone }}</span>
          <button
            type="button"
            class="copy-action"
            (click)="copyToClipboard(emp.user.phone)"
            [attr.aria-label]="'common.copy' | translate"
          >
            <img src="/icons/core/copy.svg" alt="" width="20" height="20" />
          </button>
        </div>
      </div>
      @if (emp.user.email) {
      <div class="info-row">
        <span class="info-label">{{ 'employee.email' | translate }}</span>
        <div class="info-value-with-copy">
          <span class="info-value">{{ emp.user.email }}</span>
          <button
            type="button"
            class="copy-action"
            (click)="copyToClipboard(emp.user.email!)"
            [attr.aria-label]="'common.copy' | translate"
          >
            <img src="/icons/core/copy.svg" alt="" width="20" height="20" />
          </button>
        </div>
      </div>
      }
    </div>

    @if (emp.user.roles && emp.user.roles.length > 0) {
    <div class="roles-card">
      <div class="roles-header">
        <span class="roles-title">{{ 'employee.roles' | translate }}</span>
      </div>
      <div class="roles-list">
        @for (role of emp.user.roles; track role) {
        <div class="role-badge">
          {{ 'admin.employees.roles.' + role | translate }}
        </div>
        }
      </div>
    </div>
    }

    <div class="info-card">
      <div class="toggle-row">
        <div class="toggle-info">
          <span class="toggle-label">{{
              'admin.employees.activeStatus' | translate
            }}</span>
          <span class="toggle-description">
            {{
              emp.is_active
                ? ('admin.employees.activeDescription' | translate)
                : ('admin.employees.inactiveDescription' | translate)
            }}
          </span>
        </div>
        <label class="toggle-switch" [class.disabled]="isToggling()">
          <input
            type="checkbox"
            [checked]="emp.is_active"
            (change)="onToggleActive($event)"
            [disabled]="isToggling()"
          />
          <span class="slider"></span>
        </label>
      </div>
    </div>
  </div>
  }
</div>
